import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'wouter';

import { useLayout } from '../../contexts/LayoutContext';

import { Button } from '../buttons';
import BurgerIcon from '../icons/Burger';
import SearchIcon from '../icons/Search';
import { addIcons } from '../icons/socialIcons';
import Menu from '../menus/Menu';
import Logo from './Logo';

import styles from '../../../styles/partials/top-bar.module.css';

interface MenuItem {
    label: string;
    url: string;
    external?: boolean;
    current?: boolean;
    [key: string]: unknown;
}

interface TopBarProps {
    logoLink: string;
    menuItems: MenuItem[];
    socialMenuItems: MenuItem[];
    menuOpened: boolean;
}

function TopBar({
    logoLink = null,
    menuItems = null,
    socialMenuItems = null,
    menuOpened = false,
}: TopBarProps) {
    const { setMenuOpened } = useLayout();
    const [searchOpened, setSearchOpened] = useState(false);
    // const [searchFocused, setSearchFocused] = useState(false);

    // Handle burger menu button click
    const handleBurgerClick = useCallback(() => {
        setMenuOpened(!menuOpened);
    }, [menuOpened, setMenuOpened]);

    // Handle search button click
    const handleSearchClick = useCallback(() => {
        setSearchOpened(!searchOpened);
    }, [searchOpened, setSearchOpened]);

    const handleCloseMenu = useCallback(() => {
        setMenuOpened(false);
    }, [setMenuOpened]);

    // Handle search focus change
    // const handleSearchFocusChange = useCallback(
    //     (focused: boolean) => {
    //         setSearchFocused(focused);
    //     },
    //     [setSearchFocused],
    // );

    // Handle search clear
    // const handleSearchClear = useCallback(() => {
    //     setSearchOpened(false);
    // }, [setSearchOpened]);

    // Add social icons to menu items
    const socialMenuWithIcons = addIcons(socialMenuItems, {
        color: 'currentColor',
        className: styles.icon,
    });

    return (
        <div
            className={classNames({
                [styles.container]: true,
                [styles.searchOpened]: searchOpened,
            })}
        >
            <div className={styles.cols}>
                <div className={classNames([styles.col, styles.colLeft])}>
                    <Link className={styles.logoLink} href={logoLink} aria-label="Home">
                        <Logo className={styles.logo} />
                    </Link>
                </div>
                <div className={classNames([styles.col, styles.colCenter])}>
                    <nav className={styles.menu} aria-label="Top navigation">
                        <Menu
                            items={menuItems}
                            itemsClassName={styles.items}
                            itemClassName={styles.item}
                            linkClassName={styles.link}
                            currentClassName={styles.current}
                            onClickItem={handleCloseMenu}
                        />
                    </nav>
                    {/* <div
                        className={classNames([
                            styles.search,
                            {
                                [styles.focused]: searchFocused,
                            },
                        ])}
                    >
                        <Search
                            inputClassName={styles.input}
                            clearButtonClassName={styles.clearButton}
                            onFocusChange={handleSearchFocusChange}
                            onClear={handleSearchClear}
                        />
                    </div> */}
                </div>
                <div className={classNames([styles.col, styles.colRight])}>
                    <div className={styles.cols}>
                        <div className={styles.col}>
                            <div className={styles.poweredBy}>
                                <span>
                                    <FormattedMessage
                                        defaultMessage="Propulsé par"
                                        description="Header message"
                                    />
                                </span>
                                &nbsp;
                                <a
                                    href="https://www.culturelaval.ca"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.cultureLaval}
                                >
                                    {/* <CultureLavalIcon className={styles.culture} /> */}
                                    <FormattedMessage
                                        defaultMessage="Culture Laval"
                                        description="Header message"
                                    />
                                </a>
                            </div>
                        </div>
                        <div className={styles.col}>
                            <Button
                                type="button"
                                onClick={handleSearchClick}
                                className={classNames([styles.button, styles.searchButton])}
                                aria-label="Search"
                                aria-expanded={searchOpened}
                            >
                                <SearchIcon className={styles.icon} />
                            </Button>
                            <nav className={styles.menuSocial} aria-label="Social media">
                                <Menu
                                    items={socialMenuWithIcons}
                                    itemsClassName={styles.items}
                                    itemClassName={styles.item}
                                    linkClassName={styles.link}
                                />
                            </nav>
                            <Button
                                type="button"
                                onClick={handleBurgerClick}
                                className={classNames([styles.button, styles.burgerButton])}
                                aria-label="Menu"
                                aria-expanded={menuOpened}
                            >
                                <BurgerIcon className={styles.icon} />
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopBar;
